<template>
  <div class="navigation-box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(breadcrumb,index) in breadcrumbList" :key="index" :to="breadcrumb.path">{{breadcrumb.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'page',
  props: {
    breadcrumbList: {
      type: [Array],
      default () {
        return [ ]
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.navigation-box{
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 38px;
  padding-left: 5px;
  &>*{
    font-size: 16px;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageHeader.vue"
}
</vue-filename-injector>
